import * as http from './http';

// 获取验证码接口
export const companyMaterial = (params) => http.post(`/company/info/material`, params);
//自主测评接口
export const policyvEaluating = (params) => http.post(`/policy/evaluating`, params)
//企业注册或更新
export const registerDoIdem = (params) => http.post(`/company/register/doIdem`, params);